import { RadioGroup2 } from "@/ui2/molecules/RadioGroup";
import type { RadioGroup2Props } from "@/ui2/molecules/RadioGroup";

import { QuestionIndex } from "./QuestionIndex";

type FieldsetSingleChoiceProps = {
  questionNumber?: string;
} & RadioGroup2Props;

export function FieldsetSingleChoice({
  questionNumber,
  ...radioGroupProps
}: FieldsetSingleChoiceProps) {
  return (
    <>
      <QuestionIndex questionNumber={questionNumber} />
      <RadioGroup2 {...radioGroupProps} />
    </>
  );
}
